import { useGetApplication } from 'app/hooks';

import { useCatalogValueList } from '@/app/modules/configuration/catalogs/hooks/useCatalogValueList';
import { catalogName } from '@/app/modules/configuration/catalogs/models/Catalog';
import { type TaxPayerReport } from '@/app/modules/taxes/models/Tax';
import { BaseUrlTaxpayer } from '@/app/modules/taxes/services/tax.service';

import type Paginated from '../../../../core/paginable';
import { type ReportPeriodicity } from '../components/ReportPeriodicity/types';
import { type Report } from '../models/types';

import { BaseUrlReportPeriodicity, BaseUrlReports } from './http';

export const useReport = (id: string) => {
  const [{ data, loading, error, response }] = useGetApplication<Paginated<Report>>({
    url: BaseUrlReports,
    params: {
      id,
      page: 1,
      pageSize: 1
    }
  });

  const [tax] = data?.data || [];

  return { loading, data: tax, error, response };
};

export const useReportPeriodicity = (reportId: string, id: string) => {
  const [{ data, loading, error, response }] = useGetApplication<Paginated<ReportPeriodicity>>({
    url: `${BaseUrlReports}/${reportId}${BaseUrlReportPeriodicity}`,
    params: {
      id,
      page: 1,
      pageSize: 1
    }
  });

  const [reportPeriodicity] = data?.data || [];

  return { loading, data: reportPeriodicity, error, response };
};

export const usePeriodicityTypes = () => {
  return useCatalogValueList(catalogName.periodicityType);
};

export const useGetAllTaxPayerReport = (loadMode = true) => {
  const [{ data, loading, error, response }] = useGetApplication<Array<TaxPayerReport>>(
    {
      url: `${BaseUrlTaxpayer}/report`,
      params: undefined
    },
    loadMode
  );

  return { loading, data: data, error, response };
};
